module.exports = __webpack_public_path__ + "static/media/icn-computer-science.d839c097.svg";